import axios from '../../utils/axios'


// A mock function to mimic making an async request for data
export function getTagPosts(url) {

    return axios.get(url)
  }
  